<div class="data-table-wrapper">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2" aria-describedby="data-table-wrapper">
    @for (column of columns; track column; let isFirst = $first) {
    <ng-container [matColumnDef]="column.name" [sticky]="isFirst && !isMobileScreenSize">
      <th class="text-capitalize wrap-content" mat-header-cell *matHeaderCellDef>
        {{ column.text }}
        @if (column.nextLines) { @for (nextLine of column.nextLines; track nextLine) { @if (column.text && nextLine) { &mdash; }
        {{ nextLine.text | lowercase }}
        } }
      </th>
      <td mat-cell *matCellDef="let element">
        <div>
          @if (column.name === 'year' || column.name === 'month') {
          {{ element[column.name] }}
          } @else {
          {{ element[column.name] | formatNumber }}
          }
        </div>
      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
